import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  changed(event) {
    window.location.href = event.target.value
  }
}
